import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-topaz-large.tsx
/**
* icon.24.logo.topaz.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkuMzIgMTQuNjgydjUuMzE0SDR2LTUuMzE0em01LjMzNi01LjMxNXY1LjMxNWgtNS4zMlY5LjM2N3pNMjAgMy45OTdWOS4zMWgtNS4zMlYzLjk5NnoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26876-63699
*/
const Icon24LogoTopazLarge = memo(function Icon24LogoTopazLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M9.32 14.682v5.314H4v-5.314zm5.336-5.315v5.315h-5.32V9.367zM20 3.997V9.31h-5.32V3.996z"
		})
	});
});
//#endregion
export { Icon24LogoTopazLarge };

//# sourceMappingURL=icon-24-logo-topaz-large.js.map